import ApiClient from './ApiClient';

export default class FormApi {
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getForm(formId) {
    // verify the required parameter 'groupId' is set
    if (formId === undefined || formId === null) {
      throw new Error("Missing the required parameter 'formId' when calling getForm");
    }

    return this.apiClient.get({ path: `/api/forms/${formId}` });
  }

  list() {
    return this.apiClient.get({ path: '/api/forms/' });
  }

  delete(id) {
    return this.apiClient.del({ path: `/api/forms/${id}` });
  }

  update(body) {
    // verify the required parameter 'id' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling form update");
    }
    if (body.id === undefined || body.id === null) {
      throw new Error("Missing the required parameter 'id' when calling form update");
    }
    // verify the required parameter 'body' is set
    return this.apiClient.put({ path: `/api/forms/${body.id}`, body });
  }

  create(body) {
    // verify the required parameter 'id' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling form create");
    }
    if (body.id === undefined || body.id === null) {
      throw new Error("Missing the required parameter 'id' when calling form create");
    }
    // verify the required parameter 'body' is set
    return this.apiClient.post({ path: '/api/forms', body });
  }
}
